import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STATIC_TITLES = {
  '/': 'Quran',
  '/bookmarks': 'Bookmarks · Quran',
  '/progress': 'Reading progress · Quran',
  '/duas': 'Duas · Quran',
  '/duacategories': 'Dua categories · Quran',
  '/13linepage': '13-line pages · Quran',
  '/topics-test': 'Topics · Quran',
  '/about': 'About · Quran',
  '/search': 'Search · Quran',
};

/**
 * Sets document.title for non-surah routes. Surah pages set their own titles.
 */
function RouteDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      pathname.startsWith('/surah/') ||
      pathname.startsWith('/arabicreading/')
    ) {
      return undefined;
    }
    if (pathname.startsWith('/duacategories/')) {
      document.title = 'Dua · Quran';
      return undefined;
    }
    document.title = STATIC_TITLES[pathname] || 'Quran';
    return undefined;
  }, [pathname]);

  return null;
}

export default RouteDocumentTitle;
